













  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { ListItem } from '../utils/types';
  import BaseGrid from './base-grid.vue';
  import { XOn } from './decorators/bus.decorators';

  /**
   * The `BaseVariableColumnGrid` component is a wrapper of the `BaseGrid` component that listens to
   * the `UserClickedColumnPicker` and the `ColumnsNumberProvided` events and passes the
   * selected number of columns to the grid. It also allows to customize the grid items using the
   * available `scopedSlots`.
   *
   * @public
   */
  @Component({
    components: {
      BaseGrid
    }
  })
  export default class BaseVariableColumnGrid extends Vue {
    /**
     * Animation component that will be used to animate the grid.
     *
     * @public
     */
    @Prop({ default: 'ul' })
    protected animation!: Vue | string;

    /**
     * The list of items to be rendered.
     *
     * @remarks The items must have an id property.
     *
     * @public
     */
    @Prop()
    protected items?: ListItem[];

    /**
     * The columns to render by default in the grid. This property is used when the user has not
     * selected any value in the column picker.
     *
     * @internal
     */
    @Prop({ default: 0 })
    protected columns!: number;

    /**
     * The number of columns provided by a user interaction.
     *
     * @internal
     */
    protected providedColumns: number | null = null;

    /**
     * The number of columns to render in the grid.
     *
     * @returns The number of columns.
     *
     * @internal
     */
    protected get columnsToRender(): number {
      return this.providedColumns === null ? this.columns : this.providedColumns;
    }

    /**
     * Handler to update the number of columns when the user selects a new value.
     *
     * @param newColumns - The new columns value.
     *
     * @internal
     */
    @XOn(['ColumnsNumberProvided'])
    setColumns(newColumns: number): void {
      this.providedColumns = newColumns;
    }
  }
